<div class="price-step" [formGroup]="form">
  <h3 class="title">{{ "venta-rapida.price-step.title" | translate }}</h3>
  <p class="product-name">{{ product.name }}</p>

  <div class="amount-field">
    <label class="field-label">
      {{ "venta-rapida.price-step.amount-label" | translate }}
    </label>
    <div class="amount-input-wrapper">
      <span class="currency">$</span>
      <ion-input
        #amountInput
        type="number"
        inputmode="decimal"
        formControlName="amount"
        min="0"
        placeholder="0"
        class="amount-input"
      />
    </div>
    <p class="hint">{{ "venta-rapida.price-step.hint" | translate }}</p>
  </div>

  <app-main-button
    class="generate-button"
    [label]="'venta-rapida.price-step.generate'"
    [loading]="submitting"
    [disabled]="!isValid() || submitting"
    (clicked)="onGenerate()"
  />
</div>
